/**
 * i18n configuration constants.
 *
 * This file contains ONLY the locale configuration with no side effects.
 * It can be safely imported by both the frontend app and test utilities.
 *
 * IMPORTANT: This is the single source of truth for locale configuration.
 * When adding a new locale, update ONLY this file.
 */

export const supportedLocales = ["en", "de"] as const;
export type SupportedLocale = (typeof supportedLocales)[number];

export const defaultLocale: SupportedLocale = "en";

// Maps locale to Open Graph locale format
export const ogLocales: Record<SupportedLocale, string> = {
  en: "en_US",
  de: "de_DE",
};

// Maps locale code to its English-language display name (e.g. for admin
// surfaces where the value is being read by an English-speaking admin).
export const localeLabels: Record<SupportedLocale, string> = {
  en: "English",
  de: "German",
};

// Helper to check if a locale is the default
export const isDefaultLocale = (locale: string): boolean => locale === defaultLocale;

// Helper to get locale-prefixed path
export const getLocalizedPath = (path: string, locale: string): string => {
  if (isDefaultLocale(locale)) return path;
  return path.startsWith("/") ? `/${locale}${path}` : `/${locale}/${path}`;
};
